import { Input, TextArea, Button } from '../Typography';
const Form = () => {
  return (
    <form>
      <Input label="name" placeholder="Full Name" type="text" />
      <Input label="subject" placeholder="Subject" type="text" />
      <TextArea name="message" id="message" cols="70" rows="10" placeholder="Message"></TextArea>
      <Button>Send Message</Button>
    </form>
  );
};

export default Form;
